var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('md-card',[_c('md-card-header',[_c('h1',[_vm._v(_vm._s(_vm._f("titlecase")(_vm.page.name)))])]),(_vm.page.type=='Link')?_c('md-card-header',[_vm._v("Jumping... "+_vm._s(_vm.page.content))]):_vm._e(),(_vm.page.type=='Page')?_c('md-card-content',{domProps:{"innerHTML":_vm._s(_vm.page.content)}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }